define("shared/utils/array-filters/find-unique-values-by-id", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.findUniqueValuesById = _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils"eaimeta@70e063a35619d71f
  /**
   * Takes cached and uncached values and finds the unique values based on ID.
   *
   * NOTE: Because we can't validate the non-overlapping properties of the
   * types across both arrays, non-overlapping properties will be set to
   * `unknown` and will need to be type-checked afterwards. Maybe this can
   * be improved!
   *
   * @param cachedValues Array of cached values
   * @param uncachedValues Array of uncached values
   *
   * @returns Array of unique values by id
   */
  const findUniqueValuesById = (cachedValues, uncachedValues) => {
    if ((0, _utils.isEmpty)(cachedValues)) {
      return uncachedValues;
    }

    // Get all the uncached values that don't match whats already cached
    const uniqueNewValues = uncachedValues.filter(uncachedValue => !cachedValues.any(cachedValue => cachedValue.id === uncachedValue.id));
    const result = [...cachedValues, ...uniqueNewValues];
    return result;
  };
  _exports.findUniqueValuesById = findUniqueValuesById;
  var _default = _exports.default = findUniqueValuesById;
});